import React from 'react'
import SpaceSelect, { SpaceItem } from './SpaceSelect'
import MultiSelect from './MultiSelect'
import { ISpace } from '@api/types'
import { compact } from 'lodash'

interface MultiSpaceSelectProps {
  values: ISpace[]
  onChange: (items: ISpace[]) => void
  showSeatableAndAllocatable?: boolean
  usageTypeIds?: string[]
}

export default function MultiSpaceSelect({
  values,
  onChange,
  usageTypeIds,
  showSeatableAndAllocatable,
}: MultiSpaceSelectProps) {
  const buttonProps = {
    minimal: true,
    iconName: 'plus',
    blue: true,
  }
  return (
    <MultiSelect
      title="Space"
      values={values.map((v) => (
        <SpaceItem data={v} key={v.id} />
      ))}
      select={
        <SpaceSelect
          showSeatableAndAllocatable={showSeatableAndAllocatable}
          multi
          onclose
          value={null}
          placeholder="Add"
          itemDisabled={(item) => !!values.find(({ id }) => item.id === id)}
          onChange={(s) => {
            if (s)
              values.find(({ id }) => id === s.id)
                ? onChange(values.filter(({ id }) => id !== s.id))
                : onChange(compact([...values, s]))
          }}
          usageTypeIds={usageTypeIds}
          {...{ buttonProps }}
        />
      }
      onRemove={(id) => onChange(values.filter((av) => av.id !== id))}
    />
  )
}
